import type { IAsset } from '../../../../interfaces/asset';
import type { ICustomControlRequestReadProps } from '../../interfaces/customControlRequestReadProps';
import { UserTextParagraph } from '../../../../elements/common';
import { FormLabel } from '../../../../elements/forms/FormLabel';
import { HorizontalFormGroupRead } from '../../../../elements/forms/horizontalFormGroupRead/HorizontalFormGroupRead';
import { InputContainer } from '../../../../elements/forms/InputContainer';
import { AssetThumbnailsWithHeader } from '../../../episodes/common';

interface IDermaCwondV1RequestSummaryProps extends ICustomControlRequestReadProps {
    orderedAssets: IAsset[];
}

export function DermaCwondV1RequestSummary(props: IDermaCwondV1RequestSummaryProps) {
    return (
        <>
            {props.request.customControlData.vraag && (
                <HorizontalFormGroupRead>
                    <FormLabel>Vraag</FormLabel>
                    <InputContainer>
                        <UserTextParagraph>{props.request.customControlData.vraag}</UserTextParagraph>
                    </InputContainer>
                </HorizontalFormGroupRead>
            )}

            <AssetThumbnailsWithHeader
                assets={props.orderedAssets}
                id={props.request.id}
            />
        </>
    );
}
